import { cardsData } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            吃瓜爆料
          </h2>
          <p className="text-foreground-500 text-sm">最新最热的八卦爆料，每天都有新瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.slice(0, 6).map((card) => (
            <div
              key={card.id}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 cursor-pointer hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-full aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-600 text-xs font-bold whitespace-nowrap">
                    {card.category}
                  </span>
                  <span className="text-foreground-400 text-xs whitespace-nowrap">{card.time}</span>
                </div>
                <h3 className="text-foreground-800 font-bold text-sm leading-snug line-clamp-2">
                  {card.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {cardsData.length > 6 && (
          <div className="mt-5 p-4 bg-background-50 rounded-2xl border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors duration-200">
            <div className="flex items-start gap-3">
              <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-bold whitespace-nowrap mt-0.5">
                {cardsData[6].category}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-foreground-800 font-bold text-sm leading-snug mb-1">
                  {cardsData[6].title}
                </h3>
                <span className="text-foreground-400 text-xs whitespace-nowrap">{cardsData[6].time}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}